export default "__VITE_ASSET__fc728e75__"